import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Types
export interface User {
  id: string
  email: string
  name: string
  plan: 'trial' | 'founder_beta' | 'early_adopter' | 'active' | 'expired' | 'cancelled'
  trial_start?: string
  trial_end?: string
  stripe_customer_id?: string
  lifetime: boolean
  state?: 'SA' | 'NSW' | 'QLD' | 'VIC' | 'WA' | 'NT' | 'TAS' | 'ACT'
  lhn?: string
  location_type?: 'metro' | 'regional' | 'rural' | 'remote'
  source_prefs: {
    national: string[]
    state: string[]
    local: string[]
    specialty: string[]
  }
  mode_pref: 'clinic' | 'study'
  query_count_total: number
  last_active: string
  created_at: string
}